import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";

/**
 * Related-work cross-link module — placed near the bottom of each service
 * sub-page to strengthen topical internal linking (case study proof +
 * process detail) for AEO/SEO.
 */
export const RelatedWork = ({ items = [] }) => (
  <section className="section-pad bg-white" aria-labelledby="related-heading" data-testid="related-work">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-6 font-mono">Related work</p>
        <h2 id="related-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl text-[#111111]">
          Where this shows up in practice.
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#E0E0E0]">
        {items.map((it, i) => (
          <Reveal key={it.to} delay={i * 0.06}>
            <Link
              to={it.to}
              data-testid={`related-${it.to.replace(/\//g, "-")}`}
              className="group relative block h-full p-8 md:p-10 border-r border-b border-[#E0E0E0] bg-white hover:bg-[#111111] transition-colors duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs uppercase tracking-[0.15em] text-[#999999] group-hover:text-[#666666]">{it.tag}</span>
                <ArrowUpRight size={20} className="text-[#999999] group-hover:text-white transition-all group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
              <h3 className="mt-8 font-serif text-2xl md:text-[1.7rem] text-[#111111] group-hover:text-white transition-colors">
                {it.title}
              </h3>
              <p className="mt-4 text-[#666666] group-hover:text-[#E0E0E0] transition-colors leading-relaxed">
                {it.desc}
              </p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
